var __TEMP__ = require('./_castPath.js');var castPath = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_toKey.js');var toKey = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseGet;
